import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-769ac06b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "card-title d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { id: "groups-container" }, "Your Groups", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"border-radius":"50px","position":"absolute","top":"18px","right":"23px"},
  class: "p-3"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-magnifying-glass color-white bg-lightgrey rounded-25-px p-2" })
], -1))
const _hoisted_7 = { class: "row" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body bg-lightgrey rounded-25-px text-center p-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa-solid fa-plus color-grey mb-5 mt-3",
    style: {"font-size":"50px"}
  }),
  /*#__PURE__*/_createElementVNode("h6", { class: "color-grey mb-0" }, [
    /*#__PURE__*/_createTextVNode(" New "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" GoatNote ")
  ])
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  class: "card p-5 my-5",
  style: {"width":"100%"}
}
const _hoisted_15 = { class: "card-body py-3 row p-0 m-0" }
const _hoisted_16 = { class: "card-title" }
const _hoisted_17 = { id: "template_title" }
const _hoisted_18 = {
  key: 0,
  class: "hidden-count"
}
const _hoisted_19 = { class: "row m-0 p-0" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { style: {"text-align":"center"} }, "This group has no GoatNotes", -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  class: "mx-1 d-flex justify-content-between px-1 mb-2",
  style: {"align-items":"center"}
}
const _hoisted_24 = ["title", "onClick"]
const _hoisted_25 = { class: "text-end d-flex" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pen fs-15-px border-grey bg-grey" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-trash fs-15-px border-grey" }, null, -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-eye-slash hide-un-hide fs-15-px",
  title: "click to hide GoatNote"
}, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-regular fa-share-from-square share-note fs-15-px",
  title: "click to share template"
}, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["onClick", "onUpdate:modelValue"]
const _hoisted_39 = {
  class: "modal fade",
  tabindex: "-1",
  id: "add_prompt_modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_40 = { class: "modal-dialog" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-header" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Add Prompt", -1))
const _hoisted_44 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_46 = { class: "modal-body" }
const _hoisted_47 = { class: "modal-footer" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_49 = {
  class: "modal fade",
  tabindex: "-1",
  id: "deleteTemplate_modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_50 = { class: "modal-dialog" }
const _hoisted_51 = { class: "modal-content" }
const _hoisted_52 = { class: "modal-header" }
const _hoisted_53 = {
  key: 0,
  class: "modal-title"
}
const _hoisted_54 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_56 = { class: "modal-body" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete GoatNote ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_60 = { class: "modal-footer" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_62 = {
  class: "modal fade",
  tabindex: "-1",
  id: "hide_unhide_templates_modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_63 = { class: "modal-dialog" }
const _hoisted_64 = { class: "modal-content" }
const _hoisted_65 = { class: "modal-header" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Hidden Templates", -1))
const _hoisted_67 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_69 = {
  key: 0,
  class: "modal-body hidden-modal-body m-3"
}
const _hoisted_70 = { class: "col-10 text-start" }
const _hoisted_71 = { class: "col-2 text-end" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 1,
  class: "modal-body m-3"
}
const _hoisted_74 = { class: "modal-footer" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))
const _hoisted_76 = {
  class: "modal fade",
  tabindex: "-1",
  id: "share_note_modal",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_77 = { class: "modal-dialog" }
const _hoisted_78 = { class: "modal-content" }
const _hoisted_79 = { class: "modal-header" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Share Note", -1))
const _hoisted_81 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-body m-3" }, "Coming Soon...", -1))
const _hoisted_84 = { class: "modal-footer" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ListingTokens = _resolveComponent("ListingTokens")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control rounded-25-px py-1",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchWord) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.searchForTemplateByName && _ctx.searchForTemplateByName(...args))),
            style: {"width":"20%"}
          }, null, 544), [
            [_vModelText, _ctx.searchWord]
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (grp) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card col-2 my-4 cursor-pointer",
              key: grp,
              onClick: ($event: any) => (_ctx.filterTemplatesBySpecificGroup(grp))
            }, [
              _createElementVNode("div", {
                class: "card-body rounded-25-px text-center p-3",
                style: _normalizeStyle(`background-color: ${grp.background};`)
              }, [
                (grp.hasNoTemplates)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _withModifiers(($event: any) => (_ctx.deleteGroup(grp)), ["stop"]),
                      class: "btn btn-sm btn-secondary p-1 ps-2 px-1",
                      style: {"position":"absolute","right":"5px","top":"-5px"},
                      title: "Delete group. Don't worry, it has no GoatNotes."
                    }, _hoisted_11, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                (grp.icon)
                  ? (_openBlock(), _createBlock(_component_inline_svg, {
                      key: 1,
                      class: _normalizeClass(`${grp.background === '#FFF' ? 'color-black' : 'color-white' } mb-5 mt-3`),
                      src: `/media/groups/${grp.icon}`,
                      style: {"font-size":"50px","width":"50px"}
                    }, null, 8, ["class", "src"]))
                  : (_openBlock(), _createElementBlock("i", {
                      key: 2,
                      class: _normalizeClass(`fa-solid fa-tooth ${grp.background === '#FFF' ? 'color-black' : 'color-white' } mb-5 mt-3`),
                      style: {"font-size":"50px"}
                    }, null, 2)),
                _createElementVNode("p", {
                  class: _normalizeClass(`${grp.background === '#FFF' ? 'color-black' : 'color-white' } mb-0`)
                }, _toDisplayString(grp.name), 3)
              ], 4)
            ], 8, _hoisted_8))
          }), 128)),
          _createElementVNode("div", {
            class: "card col-2 my-4 cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: `/notes/templates/new` }))),
            id: "new_template_btn"
          }, _hoisted_13)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h4", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.selectedGroup ||'Your GoatNotes') + " ", 1),
            _createElementVNode("i", {
              class: "fa-regular fa-eye-slash fs-15-px cursor-pointer mx-5",
              title: "Click to show hidden GoatNotes.",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openHideUnhideModal && _ctx.openHideUnhideModal(...args)))
            }, [
              (
                  _ctx.templates &&
                  _ctx.templates.length > 0 &&
                  _ctx.templates.filter((x) => x.hidden === true).length > 0
                )
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.templates.filter((x) => x.hidden === true).length), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_ctx.templatesToShow.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesToShow, (template, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              key: index,
              class: "card col-6 col-sm-6 col-md-6 col-lg-4 m-0 p-0",
              style: _normalizeStyle(`${_ctx.templates.length == 1 ? 'height: fit-content;' : ''};`)
            }, [
              _createElementVNode("div", {
                class: "m-5 landing-text-area pt-5 rounded-25-px",
                style: _normalizeStyle(`background-color: ${template.background || 'lightgrey'}`)
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("h6", {
                    class: "cursor-pointer template-name ps-3",
                    title: template.name,
                    onClick: ($event: any) => (_ctx.openTemplate(template.name)),
                    style: {"margin-bottom":"0px"}
                  }, _toDisplayString(template.name), 9, _hoisted_24),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-light p-1 ps-2 mx-1",
                      style: {"width":"30px"},
                      title: "Click to edit GoatNote",
                      onClick: ($event: any) => (_ctx.handleEdit($event, template))
                    }, _hoisted_28, 8, _hoisted_26),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-secondary p-1 ps-2 px-1",
                      title: "Click to delete GoatNote",
                      style: {"width":"30px"},
                      onClick: ($event: any) => (_ctx.openDeleteModal($event, template))
                    }, _hoisted_31, 8, _hoisted_29),
                    (!template.hidden)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-sm btn-secondary p-1 ps-2 mx-1",
                          title: "Click to delete GoatNote",
                          style: {"width":"30px"},
                          onClick: ($event: any) => (
                      _ctx.hideUnHideTemplate(template.templateId, !template.hidden)
                    )
                        }, _hoisted_34, 8, _hoisted_32))
                      : _createCommentVNode("", true),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-secondary p-1 ps-2 px-1",
                      title: "Click to delete GoatNote",
                      style: {"width":"30px"},
                      onClick: ($event: any) => (_ctx.shareNote(template))
                    }, _hoisted_37, 8, _hoisted_35)
                  ])
                ]),
                _withDirectives(_createElementVNode("textarea", {
                  onClick: ($event: any) => (_ctx.openTemplate(template.name)),
                  class: "form-control rounded-25-px cursor-pointer overflow-hidden",
                  id: "note-text",
                  style: {"min-height":"200px","border":"none","resize":"none"},
                  "onUpdate:modelValue": ($event: any) => ((template.text) = $event),
                  readonly: ""
                }, null, 8, _hoisted_38), [
                  [_vModelText, template.text]
                ])
              ], 4)
            ], 4)), [
              [_vShow, !template.hidden]
            ])
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_ListingTokens)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closePromptModal()))
            }, " Done ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            (_ctx.templateToDelete)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_53, " Delete GoatNote " + _toDisplayString(_ctx.templateToDelete.name), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            (_ctx.templateToDelete)
              ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                  _hoisted_58,
                  _createElementVNode("strong", null, _toDisplayString(_ctx.templateToDelete.name), 1),
                  _hoisted_59
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            (_ctx.templateToDelete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-danger",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteTemplate(_ctx.templateToDelete.templateId)))
                }, " Delete "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createElementVNode("div", _hoisted_64, [
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          (_ctx.templates.filter((x) => x.hidden === true).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templates, (row) => {
                  return _withDirectives((_openBlock(), _createElementBlock("div", {
                    class: "row my-5 hidden-row",
                    key: row.templateId
                  }, [
                    _createElementVNode("div", _hoisted_70, _toDisplayString(row.name), 1),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("i", {
                        title: "Click to un-hide GoatNote",
                        class: "fa-regular fa-eye cursor-pointer fs-15-px",
                        onClick: ($event: any) => (_ctx.hideUnHideTemplate(row.templateId, !row.hidden))
                      }, null, 8, _hoisted_72)
                    ])
                  ])), [
                    [_vShow, row.hidden]
                  ])
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_73, "No hidden templates found.")),
          _createElementVNode("div", _hoisted_74, [
            _hoisted_75,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.closeHideUnhideModal && _ctx.closeHideUnhideModal(...args)))
            }, " Done ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("div", _hoisted_81, [
              _hoisted_82,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          _hoisted_83,
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeShareNoteModal && _ctx.closeShareNoteModal(...args)))
            }, " Done ")
          ])
        ])
      ])
    ])
  ]))
}